import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect } from 'react-redux-firebase';
import { createSelector } from 'reselect';
import Stats from './Stats';
import { getWishesStats } from 'store/firebase/selectors';

const mapStateToProps = createSelector(
  getWishesStats,
  stats => ({ stats })
);

export default compose(
  firebaseConnect([
    'wishes',
    'willBuys'
  ]),
  connect(mapStateToProps)
)(Stats);



// WEBPACK FOOTER //
// ./src/components/Stats/index.js